import React, { useState, useEffect } from 'react';
import { isBrowser } from 'react-device-detect';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import ButtonBase from '../../../Buttons/ButtonBase';
import VisitsChart from '../../../Charts/VisitsChart/';
import ButtonActivate from '../../../Buttons/ButtonAction';
import moment from 'moment';
import 'moment/locale/es';
import { connect } from 'react-redux';
import firebase, {
  firestore,
} from '../../../../configs/environments/firebase/firebaseApp';
import { getMembershipData } from '../../../../store/actions/UserAction';
import './Subscribed.scss';
import { HashLink } from 'react-router-hash-link';
import * as ROUTES from '../../../../routes';
import { closeModalTutorial } from "../../../../store/actions/ModalsActions";
import { useHistory } from "react-router-dom";


const starGreen = '/img/icons/star-green-opacity.svg';
const profile = '/img/home/profile.svg';
const message = '/img/home/message.svg';
const mintCircle = '/img/icons/mono-verde.svg';
const grayCircle = '/img/icons/mono-gray.svg';
const mintMarker = '/img/icons/bandera-mint.svg';
const rewardYellow = '/img/home/completo.svg';
const rewardGray = '/img/home/desabilitado.svg';
const rewardMint = '/img/home/completo-adicional.svg';
const gold = '/img/home/gold.svg';
const platinum = '/img/home/platinum.svg';
const banderaGold = '/img/home/bandera-gold.svg';
const banderaPlatinum = '/img/home/bandera-platinum.svg';
const imgTutorial = '/img/tutoriales.svg'

const useStyles = makeStyles({
  card: {
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.12)',
  },
  cardWelcome: {
    width: '100%',
    minHeight: 88,
    padding: 24,
    margin: '0 auto 24px',
  },
});

moment.locale('es');
let startDate = moment().startOf('month').format('D');
let endDate = moment().endOf('month').format('D [de] MMMM');

function Subscribed({
  messageLaw,
  auth,
  membership,
  suscription,
  cardDefault,
  billingData,
  getMembershipData,
  closeModalTutorial
}) {
  useEffect(() => {
    billingData && billingData.idStripe && getMembershipData(billingData.idStripe, billingData.idFacturapi)
    process_opinion(auth.uid);
  }, []);
  const [rate, setRate] = useState(0);
  const history = useHistory();

  const timeMembership = moment
    .unix(auth.membership.timeMembership.seconds)
    .local();

  const nextInvoice = moment(timeMembership)
    .add(6, 'months')
    .format('DD/MM/YYYY');

  console.log('nextinvoice', nextInvoice);

  function process_opinion(uid) {
    let wholeData = [];
    let mesRef = firestore
      .collection('opinions')
      .doc(uid)
      .collection('opinion');
    let result = mesRef
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach(function (doc) {
          // doc.data() is never undefined for query doc snapshots
          wholeData.push(doc.data());
        });
      })
      .catch((error) => {});

    let x = wholeData.reduce(function (acc, obj) {
      return acc + obj.rating;
    }, 0); // 7
    let totalRate = Number(x / wholeData.length).toFixed(1);
    let num = isNaN(totalRate) ? 0 : totalRate;
    console.log('test1', num);
    setRate(num);
  }

  const classes = useStyles();

  const tituloNombre = (auth) => {
    switch (auth.gradeStudy) {
      case 'Licenciatura':
        return 'Lic.';
      case 'Mestría': {
        if (auth.genero == 'male') {
          return 'Mtro.';
        } else if (auth.genero == 'female') {
          return 'Mtra.';
        }
        return null;
      }
      case 'Especialidad':
        return 'Esp.';
      case 'Doctorado': {
        if (auth.genero == 'male') {
          return 'Dr.';
        } else if (auth.genero == 'female') {
          return 'Dra.';
        }
        return null;
      }

      default:
        return '';
    }
  };

  let lawyerAwardsArray;
  let lawfirmAwardsArray;
  if (auth.awardPerfil) {
    const {
      look,
      about,
      holder,
      collaborators,
      experience,
      contact,
      site,
    } = auth.awardPerfil;
    lawyerAwardsArray = [look, about, experience, contact, site];
    lawfirmAwardsArray = [
      look,
      about,
      holder,
      collaborators,
      experience,
      contact,
      site,
    ];
  }
  let aditionalArray;
  if (auth.awardAditional) {
    const {
      cost,
      pictures,
      videos,
      shareProfile,
      highQualification,
    } = auth.awardAditional;
    aditionalArray = [cost, pictures, videos, shareProfile, highQualification];
  }

  const countViews =
    auth.analyticsViewProfile &&
    auth.analyticsViewProfile.filter((item) =>
      moment
        .unix(item.createdAt.seconds)
        .utc()
        .isBetween(moment().startOf('month'), moment().endOf('month'))
    ).length;
  const countOpinion =
    auth.analyticsOpinion &&
    auth.analyticsOpinion.filter((item) =>
      moment
        .unix(item.createdAt.seconds)
        .utc()
        .isBetween(moment().startOf('month'), moment().endOf('month'))
    ).length;

  const calculateProfileAchievements = () => {
    let quantity;
    if (auth.awardPerfil) {
      if (auth.role === 'lawyer') {
        quantity = lawyerAwardsArray.filter((element) => element);
      } else {
        quantity = lawfirmAwardsArray.filter((element) => element);
      }
      return quantity.length;
    } else {
      return 0;
    }
  };

  const calculateAditionalAchievements = () => {
    let quantity;
    if (auth.awardAditional) {
      quantity = aditionalArray.filter((element) => element);
      return quantity.length;
    } else {
      return 0;
    }
  };

  let PROFILE_LIMIT;
  if (auth.role === 'lawyer') {
    PROFILE_LIMIT = 5;
  } else {
    PROFILE_LIMIT = 7;
  }

  const ACHIEVEMENTS_LIMIT = 5;

  const qualification =
    auth.analytics &&
    auth.analytics.opinion.qualification &&
    Number(auth.analytics.opinion.qualification);

  const getPeriod = (typePayment) => {
    let title;
    switch (typePayment) {
      case 'oneYear':
        title = 'Anual';
        break;
      case 'sixMonths':
        title = 'Mensual';
        break;
      case 'twelveMonths':
        title = 'Mensual';
        break;
      default:
        title = 'N/A';
        break;
    }
    return title;
  };

  const getPlan = (typePayment) => {
    let title;
    switch (typePayment) {
      case 'oneYear':
        title = 'Plan anual';
        break;
      case 'sixMonths':
        title = 'Plan mensual';
        break;
      case 'twelveMonths':
        title = 'Plan mensual';
        break;
      default:
        title = '';
        break;
    }
    return title;
  };

  const handleOpenTutorial = () => {
    closeModalTutorial(false,0)
    history.push('/dashboard/tutoriales')
  }

  return (
    <div className="home">
      
      <main className="home-main-subscribed" style={{ width: '100%' }}>
        <div className="home-header header-div">
          <Card className={`${classes.card} ${classes.cardWelcome}`}>
            <div className="card-welcome">
              <div>
                <p className="card-username mainTitle">
                  ¡Hola,{' '}
                  {auth && auth.role === 'lawyer' ? tituloNombre(auth) : null}{' '}
                  {auth.role === 'lawyer'
                    ? auth.name
                    : auth.officeName && auth.officeName}
                  !
                </p>
                <p>Te presentamos tu resumen de actividad</p>
              </div>
              {membership && membership.type && membership.type === 'Premium' && (
                <Link
                  to={ROUTES.MEMBERSHIPS_LAWYERS}
                >
                  <ButtonActivate variant="tertiary" className="activate">
                    ¡Mejora tu plan!
                  </ButtonActivate>
                </Link>
              )}
            </div>
          </Card>
          <div onClick={() => handleOpenTutorial()} className="content-tutorial">
            <div className="contentCenter">
              <div className="contentTutorialData">
                <div className="img-tutorial"></div>
                <p className="textTutorial">Tutoriales</p>
              </div>
            </div>
          </div>
        </div>

        <div className={isBrowser ? 'home-grades-browser' : 'home-grades'}>
          <div className="home-card card-grade">
            <div className="card-grade-content">
              <p className="title title-22">Tu calificación</p>
              {/* <p className="number">{userData.grade}</p> */}

              <p className="number">{`${qualification}/5`}</p>
              <p className="subtitle subtitle-20">Promedio</p>
              <img className="icon" src={starGreen} alt="estrella" />
              {/* <a href="/" className="link">
                Ver más
              </a> */}
            </div>
          </div>
          <div className="home-card card-grade">
            <div className="card-grade-content">
              <p className="title title-22">Visitas al perfil</p>
              {/*               <p className="number">{userData.views}</p>
               */}{' '}
              <p className="number">{countViews}</p>
              <p className="subtitle subtitle-20">{`Del ${startDate} al ${endDate}`}</p>
              <img className="icon" src={profile} alt="usuario" />
              <Link to="/dashboard/analytics" className="link">
                Ver más
              </Link>
            </div>
          </div>

          <div className="home-card card-grade">
            <div className="card-grade-content">
              <p className="title title-22">Opiniones recibidas</p>
              {/* <p className="number">{userData.opinions}</p> */}
              <p className="number">{countOpinion}</p>
              <p className="subtitle subtitle-20">{`Del ${startDate} al ${endDate}`}</p>
              <img className="icon" src={message} alt="mensaje" />
              <Link to="/dashboard/opiniones" className="link">
                Ver más
              </Link>
            </div>
          </div>
        </div>

        <div className="home-chart_contacts">
          <VisitsChart authClient={auth} />
          <div
            className={
              isBrowser
                ? 'home-card card-contacts-browser'
                : 'home-card card-contacts'
            }
          >
            <div className="card-contacts-content">
              <Link to="/dashboard/mensajes" className="link">
                Ver más
              </Link>
              <p className="title-blue title-22">Contactos guardados</p>
              <div className="contact-list">
                {messageLaw && messageLaw.length > 0 ? (
                  messageLaw.map((contact, index) => {
                    if (contact.save) {
                      return (
                        <div className="item" key={index}>
                          <img
                            className="marker"
                            src={mintMarker}
                            alt="contacto guardado"
                          />

                          <img
                            src={contact.client ? mintCircle : grayCircle}
                            style={{
                              width: 16,
                              height: 16,
                              margin: '0 8px 0 0',
                            }}
                            alt="usuario registrado"
                          />
                          <div>
                            <p className="title title-14">{contact.name}</p>
                            <br />
                            <small className="subtitle-12">
                              {contact.phone}
                            </small>
                          </div>
                        </div>
                      );
                    }
                  })
                ) : (
                  <p className="title title-14">Sin Contactos</p>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="home-typeOfMembership">
          <div className="home-card card-membership">
            <div className="card-membership-content">
              <div className="membership-name" style={{ display: 'flex' }}>
                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                  <div className="type-memb">
                    <span className='title title-22-premium'>
                      Membresía Premium  
                    </span>
                  </div>
                  <span
                    className={`title title-22-${
                      auth.membership &&
                      auth.membership.gift &&
                      membership.gift === '300'
                        ? 'limon'
                        : 'texto'
                    }`}
                  >
                    {membership.type === 'Premium' &&
                    membership.gift &&
                    membership.gift === '300'
                      ? 'SEIS MESES GRATIS'
                      : membership.type === 'Freemium'
                      ? 'Plan gratuito'
                      : ` ${getPlan(membership.typePayment)}`}
                  </span>
                </div>
              </div>
              <small>Actualmente activa</small>
              <div className="membership-details">
                <div className="membership-details-container">
                  <div>
                    <div className="data-wrapper">
                      <p className="text">Tu próxima factura</p>
                      <p className="subtitle">
                        {suscription && suscription.current_period_end
                          ? moment
                              .unix(suscription.current_period_end)
                              .utc()
                              .format('DD/MM/YYYY')
                          : 'N/A'}
                        {/* nextInvoice? nextInvoice : '--' */}
                      </p>
                    </div>
                    <div className="data-wrapper">
                      <p className="text">Monto membresía</p>
                      <p className="subtitle">
                        {membership.type
                          ? `$${membership.cost ? membership.cost : '0'}.- MXN`
                          : '$0.- MXN'}
                      </p>
                    </div>
                    <div className="data-wrapper">
                      <p className="text">Periodo de pago</p>
                      <p className="subtitle">
                        {getPeriod(membership.typePayment)}
                      </p>
                    </div>
                  </div>

                  <div>
                    <div className="data-wrapper" style={{ width: 320 }}>
                      <p className="text">Método de pago</p>
                      <p className="subtitle">
                      {cardDefault && cardDefault.cards && cardDefault.cards.length ?  (`${cardDefault.cards[0].brand} **** **** **** ${cardDefault.cards[0].last4}`) : 'Sin método de pago'}
                      </p>
                    </div>
                    {/* <div className="data-wrapper">
                      <p className="text">Monto total</p>
                      <p className="subtitle">$0.-MXN</p>
                    </div> */}
                    {/* {auth.membership && auth.membership.type === 'Premium' && (
                      <ButtonBase
                        variant="primary"
                        style={{ width: 216, height: 40, padding: 0 }}
                      >
                        ¡Quiero ser Premium Plus!
                      </ButtonBase>
                    )} */}
                    {auth.membership &&
                      auth.membership.type === 'Premium Plus' && (
                        <Link to={ROUTES.MEMBERSHIP_PAYMETHOD}>
                          <ButtonBase
                            variant="primary"
                            style={{
                              width: 216,
                              height: 40,
                              padding: 0,
                              marginBottom: 24,
                            }}
                          >
                            Ingresar método de pago
                          </ButtonBase>
                        </Link>
                      )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="home-card card-rewards">
            <div className="card-rewards-content">
              <p className="title title-22">Logros obtenidos</p>
              <HashLink smooth to="/dashboard/perfil/#progress">
                <span className="link">Ver más</span>
              </HashLink>
              <div className="reward-list">
                <div>
                  <p className="title title-14">Recompensas del perfil</p>
                  <div className="results">
                    <div className="reward-icons">
                      {auth.role === 'lawyer'
                        ? lawfirmAwardsArray &&
                          lawyerAwardsArray
                            .sort()
                            .reverse()
                            .map((element, index) => {
                              if (element) {
                                return (
                                  <img
                                    className="reward"
                                    src={rewardYellow}
                                    alt="logro obtenido"
                                    key={index}
                                  />
                                );
                              } else {
                                return (
                                  <img
                                    className="reward"
                                    src={rewardGray}
                                    alt="logro no obtenido"
                                    key={index}
                                  />
                                );
                              }
                            })
                        : lawfirmAwardsArray &&
                          lawfirmAwardsArray
                            .sort()
                            .reverse()
                            .map((element, index) => {
                              if (element) {
                                return (
                                  <img
                                    className="reward"
                                    src={rewardYellow}
                                    alt="logro obtenido"
                                    key={index}
                                  />
                                );
                              } else {
                                return (
                                  <img
                                    className="reward"
                                    src={rewardGray}
                                    alt="logro no obtenido"
                                    key={index}
                                  />
                                );
                              }
                            })}
                    </div>
                    <span className="title title-14">
                      {calculateProfileAchievements()}/{PROFILE_LIMIT}
                    </span>
                  </div>
                </div>
                <div>
                  <p className="title title-14">Recompensas adicionales</p>
                  <div className="results">
                    <div className="reward-icons">
                      {lawfirmAwardsArray &&
                        aditionalArray
                          .sort()
                          .reverse()
                          .map((element, index) => {
                            if (element) {
                              return (
                                <img
                                  className="reward"
                                  src={rewardYellow}
                                  alt="logro obtenido"
                                  key={index}
                                />
                              );
                            } else {
                              return (
                                <img
                                  className="reward"
                                  src={rewardGray}
                                  alt="logro no obtenido"
                                  key={index}
                                />
                              );
                            }
                          })}
                    </div>
                    <span className="title title-14">
                      {calculateAditionalAchievements()}/{ACHIEVEMENTS_LIMIT}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

const mapDispatchToProps = dispatch => ({
  getMembershipData: (idStripe, idFacturapi) => dispatch(getMembershipData(idStripe,idFacturapi)),
  closeModalTutorial: (open, numerTutorial) => dispatch(closeModalTutorial(open, numerTutorial)),
})

const mapStateToProps = (state) => ({
  messageLaw: state.authClient.messageLaw,
  membership: state.authClient.membership,
  role: state.authClient.role,
  cardDefault: state.authClient.membershipData,
  billingData: state.billingReducer.billingData,
});

export default connect(mapStateToProps, mapDispatchToProps)(Subscribed);
